export default __webpack_public_path__ + "static/media/inputSVG.625c6e40.svg";